import React, { createContext, useState, useEffect, useContext, useCallback, useMemo } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import SubscriptionBanner from '../components/SubscriptionBanner';
import PlanUsageBanner from '../components/PlanUsageBanner';
import { SubscriptionProvider } from '../contexts/SubscriptionContext';

export const SidebarContext = createContext({ onToggle: () => {}, collapsed: false });

export function useSidebar() {
  return useContext(SidebarContext);
}

const STORAGE_KEY = 'sidebar_collapsed';

function DashboardLayout() {
  const [collapsed, setCollapsed] = useState(() => localStorage.getItem(STORAGE_KEY) === 'true');
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia('(max-width: 767px)');
    const handler = (e) => setIsMobile(e.matches);
    mq.addEventListener('change', handler);
    setIsMobile(mq.matches);
    return () => mq.removeEventListener('change', handler);
  }, []);

  const isCollapsed = isMobile || collapsed;

  const onToggle = useCallback(() => {
    if (isMobile) return;
    setCollapsed((prev) => {
      const next = !prev;
      localStorage.setItem(STORAGE_KEY, String(next));
      return next;
    });
  }, [isMobile]);

  const sidebarValue = useMemo(
    () => ({ onToggle, collapsed: isCollapsed }),
    [onToggle, isCollapsed]
  );

  return (
    <SubscriptionProvider>
      <SidebarContext.Provider value={sidebarValue}>
        <div className="flex min-h-screen bg-gray-50">
          <Sidebar isCollapsed={isCollapsed} onToggle={onToggle} />
          <main className="flex-1 flex flex-col min-w-0">
            <SubscriptionBanner />
            <PlanUsageBanner />
            <Outlet />
          </main>
        </div>
      </SidebarContext.Provider>
    </SubscriptionProvider>
  );
}

export default DashboardLayout;